// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2N8m3","choiceBoxes":"toolbarselects_choiceBoxes__3rG9j","simpleField":"toolbarselects_simpleField__3QvmL"};